import React, { useEffect, useState } from 'react';
import { Form, Button, Table, InputGroup } from 'react-bootstrap';
import { adminInstance } from '../services/axiosInstance'; 
import LoaderOverlay from '../Components/shared/Loader';

const SparesManagerPage = () => {
  const [subGroups, setSubGroups] = useState([]);
  const [spares, setSpares] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [subGroupId, setSubGroupId] = useState(0);
    const [loadItems, setLoadItems] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchSubGroup();
  }, []);

    const fetchSubGroup = async () => {
        setIsLoading(true);
    const res = await adminInstance.get(`subgroup/get`);
        setSubGroups(res.data.subGroups);
        setIsLoading(false);
  };

  const fetchSpares = async (subGrpId) => {
      debugger;
      setIsLoading(true);
    const res = await adminInstance.get(`subgroup/GetSparesMasterBySubGroup/${subGrpId}/${loadItems}`);
    const checkedIds = res.data?.subGroupItems?.map(x => x.ItemCode) || [];

    if(loadItems === 1){
      setSpares(res.data.items || []);
      setLoadItems(0);
    }
      setSelectedIds(checkedIds);
      setIsLoading(false);
  };

  const handleCheck = (ItemCode) => {
    setSelectedIds(prev =>
      prev.includes(ItemCode) ? prev.filter(x => x !== ItemCode) : [...prev, ItemCode]
    );
  };

    const handleSave = async () => {
        debugger;
        var prodName = subGroups.filter(s => s.SubGroupId === parseInt(subGroupId))[0]?.SubGroupName;
        const confirmSave = window.confirm(`Are you sure you want to save the selected items for the Product ${prodName}?`);

        if (!confirmSave) return;

        try {
            setIsLoading(true);

            await adminInstance.put(
                `subgroup/UpdateSparesBySubGroup/${subGroupId}`,
                selectedIds
            );

            alert("Items saved successfully!");
        } catch (error) {
            alert("Failed to save items!");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

  debugger;
  const filteredSpares = spares
    .filter(spare =>
      spare.ItemName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.ItemCode?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      const aChecked = selectedIds.includes(a.ItemCode) ? -1 : 1;
      const bChecked = selectedIds.includes(b.ItemCode) ? -1 : 1;
      return aChecked - bChecked;
    });

    return (
        <>
            <LoaderOverlay loading={isLoading} message="Loading" height="500px" />
      
            <div className="card aon-card">
        <div className="card-header aon-card-header">
            <h4>
                Item Manager
            </h4>
        </div>
        <div className="card-body aon-card-body">
            <div className="container mt-4">
      <h4>Manage Items for SubGroup</h4>

        <div class="row">
            <div className="col-md-4">
                <div className="form-group">
                    {/* <label>Select Category</label> */}
                    <select
                        className="form-control sf-form-control"
                        value={subGroupId}
                        onChange={(e) => {
                            setSubGroupId(e.target.value);
                            fetchSpares(e.target.value);
                        }}
                    >
                        <option value="">Select Product</option>
                        {subGroups && subGroups.length > 0 && subGroups?.map((item) => (
                            <option key={item.SubGroupCode} value={item.SubGroupId}>
                                {item.SubGroupCode + '-'} {item.SubGroupName}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="col-md-6">
                                <button className="admin-button" style={{ marginRight: 20 }} onClick={() => fetchSpares(subGroupId)}>
                    Load
                </button> 
                <Button variant="primary" onClick={() => handleSave()}>
                  Save Items
                </Button>
            </div>            
        </div>      

      <Table bordered hover responsive>
        <thead>
          <tr>            
            <th>Select</th>
            <th>Code</th>
            <th>Item Name</th>
            <th>Published</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={4}>
              <InputGroup className="mb-3">
                <Form.Control
                  placeholder="Search items..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </td>
          </tr>
          {filteredSpares.map(spare => (
            <tr key={spare.ItemCode}>
              <td>
                <Form.Check
                  type="checkbox"
                  checked={selectedIds.includes(spare.ItemCode)}
                  onChange={() => handleCheck(spare.ItemCode)}
                />
              </td>
              <td>{spare.ItemCode}</td>
              <td>{spare.ItemName}</td>
              <td>{spare.IsPublish ? "Yes" : "No"}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      
            </div>
        </div>
            </div>
        </>
  );
};

export default SparesManagerPage;
